var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestionMarkWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.227 19.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffffff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question",
    transform: "translate(-0.003 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(0.003 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-1",
    d: "M19.154,17.411l-1.32-3.841A9.393,9.393,0,1,0,9.4,18.8h.015a9.431,9.431,0,0,0,4.153-.973l3.841,1.32a1.38,1.38,0,0,0,.449.076,1.371,1.371,0,0,0,1.291-1.815Zm-1.133.607a.22.22,0,0,1-.237.055l-4.07-1.4a.57.57,0,0,0-.452.035,8.259,8.259,0,1,1,3.45-3.45.57.57,0,0,0-.035.452l1.4,4.07A.22.22,0,0,1,18.021,18.018Z",
    transform: "translate(-0.003 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(8.742 13.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-1",
    d: "M233.29,362.748a.57.57,0,1,0,.57.57A.576.576,0,0,0,233.29,362.748Z",
    transform: "translate(-232.719 -362.748)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(6.476 4.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-1",
    d: "M175.231,127.674a2.839,2.839,0,0,0-2.836,2.836.57.57,0,1,0,1.14,0,1.7,1.7,0,1,1,1.7,1.7.57.57,0,0,0-.57.57V135.1a.57.57,0,1,0,1.14,0v-1.812a2.836,2.836,0,0,0-.57-5.614Z",
    transform: "translate(-172.395 -127.674)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionMarkWhite);
export default __webpack_public_path__ + "static/media/icon_question_mark_white.880fbf4c0909481d4690b90bbda96799.svg";
export { ForwardRef as ReactComponent };